import React from "react";
import VehiculosRegistradosList from "../../components/MovilidadElectrica/VehiculosRegistradosList";
import { MovilidadElectricaProvider } from "../../context/MovilidadElectricaContext";

const VehiculosRegistrados = () => {
  return (
    <MovilidadElectricaProvider>
      <VehiculosRegistradosList />
    </MovilidadElectricaProvider>
  );
};

export default VehiculosRegistrados;
